import { LyMainProductFormBase } from "./base"
import { renderLyPopoverV4 } from "@/utils/renders"
// import { addLinkPointCameraPosition, addLinkPointCameraPositionByGroup } from './link_point_camera_position'

if (!customElements.get('ly-main-product-form-sidewall-picker')) {
    customElements.define('ly-main-product-form-sidewall-picker', class extends LyMainProductFormBase {

        jsRenderWrapper = null

        activedId = null
        activedKey = null

        allModelConfigMap = {}
        hydratedVariantConfigCache = new Map()
        hydratedModelConfigCache = new Map()

        connectedCallback() {
            super.connectedCallback()

            this.jsRenderWrapper = this.querySelector('.js-render-wrapper')
        }

        disconnectedCallback() {
            super.disconnectedCallback()
        }

        _transformVariantConfigs = data => {
            this.allModelConfigMap = data.allModelConfigMap || {}

            this.hydratedVariantConfigCache.clear()
            this.hydratedModelConfigCache.clear()

            return data.variantConfigs || {}
        }

        _onVariantChange = ({ variantId, activedKey }) => {
            this.activedId = variantId
            this.activedKey = activedKey

            const config = this.resolveVariantConfig(variantId)

            if (!config) return

            if (config.hasModel) {
                this.jsRenderWrapper.innerHTML = this.renderNormalType(config)

                // addLinkPointCameraPosition()
            } else {
                this.jsRenderWrapper.innerHTML = this.renderJoinType(config)

                // addLinkPointCameraPositionByGroup()
            }
        }

        resolveVariantConfig = variantId => {
            const id = String(variantId)

            const cached = this.hydratedVariantConfigCache.get(id)

            if (cached) {
                return cached
            }

            const config = this._variantConfigs[id]

            if (!config) return null

            const hydrated = this.hydrateConfig(config)

            this.hydratedVariantConfigCache.set(id, hydrated)

            return hydrated
        }

        hydrateConfig = config => {
            return {
                ...config,
                linkPoints: this.hydrateLinkPoints(config.linkPoints)
            }
        }

        hydrateLinkPoints = (linkPoints = []) => {
            return linkPoints.map(linkPoint => {
                const { modelConfigHandles, ...rest } = linkPoint
                return {
                    ...rest,
                    modelConfigs: (modelConfigHandles || [])
                        .map(this.hydrateModelConfig)
                        .filter(Boolean)
                }
            })
        }

        hydrateModelConfig = handle => {
            const cache = this.hydratedModelConfigCache.get(handle)

            if (cache) {
                return cache
            }

            const config = this.allModelConfigMap[handle]

            if (!config) {
                console.warn(`[ly-main-product-form-sidewall-picker] 找不到 model config`, handle)
                return null
            }

            const hydrated = {
                ...config,
                linkPoints: this.hydrateLinkPoints(config.linkPoints)
            }

            this.hydratedModelConfigCache.set(handle, hydrated)

            return hydrated
        }

        /** 渲染常规款式 */
        renderNormalType = (config, prefix = '') => {
            const html = config.linkPoints.map(linkPoint => {
                const handlePrefix = `${prefix}${config.handle},${linkPoint.handle}`
                return this.renderSide(handlePrefix, linkPoint)
            }).join('')
            return `<div class="ly-main-product-form-sidewall-picker-side-wrapper">${html}</div >`
        }

        /** 渲染单面 */
        renderSide = (handlePrefix, linkPoint) => {
            return `
            <ly-main-product-form-sidewall-picker-side class="ly-main-product-form-sidewall-picker-side">
              <label class="ly-main-product-form-sidewall-picker-side-preview" for="${handlePrefix}">
                <div class="add-button btn">
                  <span class="svg-wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/></svg>
                  </span>
                </div>
                <label class="clear-button btn">
                  <span class="svg-wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/></svg>
                  </span>
                </label>
              </label>

              <div class="ly-main-product-form-sidewall-picker-side-title">
                <span>${linkPoint.showTitle}</span>
              </div>

              ${this.renderSidePopover(linkPoint, handlePrefix)}
            </ly-main-product-form-sidewall-picker-side>
            `
        }

        renderSidePopover = (linkPoint, handlePrefix) => {
            const html = linkPoint.modelConfigs.map(modelConfig => {
                const handleChain = `${handlePrefix},${modelConfig.handle}`

                const disabledConfig = linkPoint.disabledConfigs?.find(disabledConfig => {
                    return disabledConfig.in_variants.some(id => id === `gid://shopify/ProductVariant/${this.activedId}`)
                })

                return modelConfig.variants.map(variant => {
                    let disabled = false
                    if (disabledConfig) {
                        disabled = disabledConfig.disabled_variants.some(id => id === `gid://shopify/ProductVariant/${variant.id}`)
                    }
                    return this.renderSidePopoverSidewall(handleChain, variant, disabled, modelConfig)
                }).join('')
            }).join('')

            return renderLyPopoverV4(
                handlePrefix,
                `Add ${linkPoint.showTitle}`,
                `
                <div class="ly-main-product-form-sidewall-picker-side-popover-wrapper">
                    <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-wrapper">
                    ${html}
                    </div>
                </div>`)
        }

        get imageKey() {
            return this.activedKey.split(' | ').slice(0, -1).join(' | ')
        }

        renderSidePopoverSidewall = (handleChain, variant, disabled, modelConfig) => {
            const image = variant.images[this.imageKey] || variant.images.fallback

            const src = `${image}&width=200`
            const srcset = [200, 180, 400, 360, 600].map(size => `${image}&width=${size} ${size}w`).join(', ')

            let freeUpgradeActivityTagHtml = ``
            if (variant.sidewall_free_upgrade_activity) {
                freeUpgradeActivityTagHtml = `
                <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-tag free-upgrade-activity-tag">
                  ${variant.sidewall_free_upgrade_activity.tag}
                </div>
                `
            }

            let discountTagHtml = ``
            if (variant.originalPrice > variant.currentPrice) {
                const percent = (variant.originalPrice - variant.currentPrice) / variant.originalPrice * 100
                discountTagHtml = `<div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-tag discount-tag" > -${Math.ceil(percent)}%</div >`
            }

            let disabledHtml = ''
            if (disabled) {
                const reason = variant.disabledReason
                if (reason) {
                    disabledHtml = `
                    <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-disabled-info">
                      <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-disabled-info-header">
                        <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-disabled-info-title">
                          ${reason.title}
                        </div>
                        <label>
                          <div class="svg-wrapper">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="6" cy="6" r="5.5" stroke="white"/>
                              <path d="M5.592 6.944L5.376 4.208L5.336 3.016H6.664L6.624 4.208L6.408 6.944H5.592ZM6 9.072C5.79733 9.072 5.62933 9.00533 5.496 8.872C5.36267 8.73867 5.296 8.57067 5.296 8.368C5.296 8.16 5.36267 7.98933 5.496 7.856C5.62933 7.72267 5.79733 7.656 6 7.656C6.20267 7.656 6.37067 7.72267 6.504 7.856C6.63733 7.98933 6.704 8.16 6.704 8.368C6.704 8.57067 6.63733 8.73867 6.504 8.872C6.37067 9.00533 6.20267 9.072 6 9.072Z" fill="white"/>
                            </svg>
                          </div>
                          <input type="checkbox" class="ly-hide">
                        </label>
                      </div>
                      <div class="variant-disabled-divider"></div>
                      <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-disabled-info-body">
                        <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-disabled-info-description">
                          ${reason.more_description}
                        </div>
                      </div>
                    </div>
                    `
                }
            }

            let preOrderHtml = ''
            if (variant.preOrderTime && variant.inventory <= 0) {
                preOrderHtml = `
                <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-pre-order">
                  <span>${document.documentElement.dataset.preOrderSuffixText}</span>
                  <ly-format-time data-time="${variant.preOrderTime.time}"></ly-format-time>
                </div>
                `
            }

            const currentPrice = this.formatter.format(variant.currentPrice / 100)
            const originalPrice = variant.originalPrice > variant.currentPrice ? this.formatter.format(variant.originalPrice / 100) : ''

            const sidewallAccessoryHtml = this.renderSidePopoverSidewallAccessory(modelConfig, disabled, handleChain, variant.sidewallAccessoryPreviewImages[this.imageKey], variant.sidewall_free_upgrade_activity)

            // 跟showroom相关的内容不用加到这里， 因为showroom不参与variant切换
            return `
            <ly-main-product-form-sidewall-picker-side-popover-sidewall class="ly-main-product-form-sidewall-picker-side-popover-sidewall ${disabled ? 'is-disabled' : ''}" data-preview-url="${src}">
                <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-top">
                  <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-image">
                    <img src="${src}" srcset="${srcset}" width="180" height="100" loading="eager">

                    <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-tags">
                        ${freeUpgradeActivityTagHtml}
                        ${discountTagHtml}
                    </div>

                    ${disabledHtml}
                  </div>

                  <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-title">${variant.productTitle}</div>
                  <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-options">${variant.options}</div>
                  <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-price">
                    <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-current-price">
                      ${currentPrice}
                    </div>
                    <s class="ly-main-product-form-sidewall-picker-side-popover-sidewall-original-price">
                      ${originalPrice}
                    </s>
                  </div>

                  ${preOrderHtml}
                </div>

                <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-bottom">
                  ${sidewallAccessoryHtml}
                  <label class="ly-main-product-form-sidewall-picker-side-popover-sidewall-pick-button">
                    ${this.dataset.pickBtnText}
                    <input
                      type="checkbox"
                      class="ly-hide ly-main-product-form-sidewall-picker-side-popover-sidewall-picker-checkbox"
                      data-handle-chain="${handleChain}"
                      data-preview-url="${image}"
                      data-original-price="${variant.originalPrice}"
                      data-current-price="${variant.currentPrice}"
                      data-variant-id="${variant.id}"
                      data-installation-service-price="${variant.installationService.currentPrice}"
                      data-installation-service-original-price="${variant.installationService.originalPrice ?? ''}"
                      data-installation-service-variant-id="${variant.installationService.id}"
                      ${disabled ? 'disabled' : ''}
                    >
                    
                    ${this.createOrderSummarySkuConfigHtml(variant, image)}
                  </label>
                </div>
            </ly-main-product-form-sidewall-picker-side-popover-sidewall>
            `
        }

        renderSidePopoverSidewallAccessory = (modelConfig, disabled, handlePrefix, previewImage, sidewall_free_upgrade_activity) => {
            if (!modelConfig.linkPoints.length) return ''

            const [linkPoint] = modelConfig.linkPoints

            const itemsHtml = linkPoint.modelConfigs.map(modelConfig => {
                const handleChain = `${handlePrefix},${linkPoint.handle},${modelConfig.handle}`
                return modelConfig.variants.map(variant => {
                    const image = variant.images[this.imageKey] || variant.images.fallback

                    const src = `${image}&width=38`
                    const srcset = [38, 70, 76, 140, 210].map(size => `${image}&width=${size} ${size}w`).join(', ')

                    return `
                    <label class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-item">
                        <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-item-image">
                          <img src="${src}" srcset="${srcset}" sizes="(max-width: 767px) 70px, 38px" width="70" height="54" loading="lazy">
                        </div>

                        <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-item-title">
                          ${variant.title === 'Default Title' ? variant.productTitle : variant.title}
                        </div>

                        <input
                          type="radio"
                          name="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-item-picker-radio-${handlePrefix}"
                          class="ly-hide ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-item-picker-radio"
                          data-handle-chain="${handleChain}"
                          data-preview-url="${previewImage || image}"
                          data-original-price="${variant.originalPrice}"
                          data-current-price="${variant.currentPrice}"
                          data-variant-id="${variant.id}"
                          data-installation-service-price="${variant.installationService.currentPrice}"
                          data-installation-service-original-price="${variant.installationService.originalPrice ?? ''}"
                          data-installation-service-variant-id="${variant.installationService.id}"
                          ${sidewall_free_upgrade_activity ? 'data-in-sidewall-free-upgrade-activity' : ''}
                        >

                        ${this.createOrderSummarySkuConfigHtml(variant, previewImage || image)}
                    </label>
                    `
                }).join('')
            }).join('')

            let freeUpgradeActivityHtml = ``
            if (sidewall_free_upgrade_activity) {
                freeUpgradeActivityHtml = `
                <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-free-upgrade-activity-wrapper">
                  <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-free-upgrade-activity-title">
                    <span class="title1">${sidewall_free_upgrade_activity.title1}</span>
                    <span class="title2">${sidewall_free_upgrade_activity.title2}</span>
                  </div>
                  <ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-free-upgrade-activity-time-counter data-end-time="${sidewall_free_upgrade_activity.end_time || ''}">
                    <span class="end-title">${sidewall_free_upgrade_activity.end_title || 'Ends in:'}</span>
                    <span class="day">00</span>
                    <span class="divider">:</span>
                    <span class="hur">01</span>
                    <span class="divider">:</span>
                    <span class="min">01</span>
                    <span class="divider">:</span>
                    <span class="sec">60</span>
                  </ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-free-upgrade-activity-time-counter>
                </div>
                `
            }

            return `
            <ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory" ${sidewall_free_upgrade_activity ? 'data-in-sidewall-free-upgrade-activity' : ''}>
              <label class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-trigger">
                <input class="ly-checkbox ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-trigger-input" type="checkbox" ${disabled ? 'disabled' : ''}>
                <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-title">
                  ${linkPoint.showTitle}
                </div>
              </label>
                    
              <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-wrapper ly-expandable-grid">
                <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-inner-wrapper ly-expandable-grid-inner">
                  <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-inner">
                    <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-price-wrapper">
                      <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-current-price"></div>
                      <s class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-original-price"></s>
                    </div>
                    <div class="ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-items">
                      ${itemsHtml}
                    </div>
                  </div>
                </div>
              </div>

              ${freeUpgradeActivityHtml}
            </ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory>
            `
        }

        /** 渲染拼接款式 */
        renderJoinType = (config) => {
            const html = config.linkPoints.map(linkPoint => {
                const [modelConfig] = linkPoint.modelConfigs
                return `
                <div class="ly-main-product-form-sidewall-picker-group-wrapper">
                  <div class="ly-main-product-form-sidewall-picker-group-header">${linkPoint.showTitle}</div>

                  <div class="ly-main-product-form-sidewall-picker-group-body">
                    ${this.renderNormalType(modelConfig, linkPoint.handle + ',')}
                  </div>
                </div>
                `
            }).join('')

            return html
        }
    })
}

if (!customElements.get('ly-main-product-form-sidewall-picker-side')) {
    customElements.define('ly-main-product-form-sidewall-picker-side', class extends HTMLElement {

        get checkedSidewall() {
            return this.sidewalls.find(item => item.contains(this.checkedSidewallInput))
        }

        checkedSidewallInput = null
        checkedSidewallAccessoryInput = null
        sidewalls = []
        sidewallInputs = []
        sidewallAccessoryInputs = []

        async connectedCallback() {
            await customElements.whenDefined('ly-popover-v4')
            this.popper = this.querySelector('ly-popover-v4')

            // 先把 template 内容 append 到真实 DOM
            this.popper.renderBody()

            const popoverBodyContent = this.popper.bodyContent

            this.sidewalls = [...popoverBodyContent.querySelectorAll('ly-main-product-form-sidewall-picker-side-popover-sidewall')]
            this.sidewallInputs = [...popoverBodyContent.querySelectorAll('.ly-main-product-form-sidewall-picker-side-popover-sidewall-picker-checkbox')]
            this.sidewallAccessoryInputs = [...popoverBodyContent.querySelectorAll('.ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-item-picker-radio')]

            this.previewWrapper = this.querySelector('.ly-main-product-form-sidewall-picker-side-preview')
            this.clearBtn = this.previewWrapper.querySelector('.clear-button')

            this.sidewallInputs.forEach(item => {
                item.addEventListener('change', this.handleSidewallChange)
            })
            this.clearBtn.addEventListener('click', this.handleClear)
            this.popper.addEventListener('visibility_change', this.handlePopoverChange)
            this.addEventListener('sidewall_accessory_change', this.handleSidewallAccessoryChange)

            this.sidewalls.forEach((item) => {
                item?.handleShowroom?.()
            })
        }

        disconnectedCallback() {
            this.sidewallInputs.forEach(item => {
                item.removeEventListener('change', this.handleSidewallChange)
            })
            this.clearBtn?.removeEventListener('click', this.handleClear)
            this.popper?.removeEventListener('visibility_change', this.handlePopoverChange)
            this.removeEventListener('sidewall_accessory_change', this.handleSidewallAccessoryChange)
        }

        /** 边墙变化 */
        handleSidewallChange = (evt) => {
            const { target } = evt

            this.sidewallInputs.forEach(item => {
                if (item === target) return
                item.checked = false
            })

            // 从一个sidewall切换到另一个sidewall时，清空accessory
            if (this.checkedSidewallInput !== target && this.checkedSidewallInput) {
                this.clearSidewallAccessory()
            }

            if (target.checked) {
                this.checkedSidewallInput = target

                const checkedSidewallAccessoryInputs = this.sidewallAccessoryInputs.filter(input => input.checked)
                this.checkedSidewallAccessoryInput = checkedSidewallAccessoryInputs.find(input => this.checkedSidewall?.contains(input)) ?? null
                this.publishSidewallAccessoryChangeEvent()
            }

            this.publishSidewallChangeEvent()

            if (!target.checked) {
                if (this.checkedSidewallAccessoryInput) {
                    this.clearSidewallAccessory()
                }
                this.checkedSidewallInput = null
            }

            this.updatePreview()

            /** 关闭弹窗 */
            this.popper.close()
        }

        sidewallToAccessory = new WeakMap()
        /** 清空accessory */
        clearSidewallAccessory = () => {
            let accessory = this.sidewallToAccessory.get(this.checkedSidewall)
            if (!accessory) {
                accessory = this.checkedSidewall.querySelector('ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory')
            }
            if (!accessory) return
            if (accessory.triggerInput.checked) {
                accessory.triggerInput.checked = false
                accessory.triggerInput.dispatchEvent(new Event('change'))
            }
        }

        /** 发布边墙change事件 */
        publishSidewallChangeEvent = () => {
            if (!this.checkedSidewallInput) return
            const { checked, dataset: { handleChain, variantId } } = this.checkedSidewallInput
            window.publish('bus:sidewall_picker_changed', { checked, handleChain, variantId })
        }

        /** 发布边墙配件change事件 */
        publishSidewallAccessoryChangeEvent = () => {
            if (!this.checkedSidewallAccessoryInput) return
            const { checked, dataset: { handleChain, variantId } } = this.checkedSidewallAccessoryInput
            window.publish('bus:sidewall_accessory_picker_changed', { checked, handleChain, variantId })
        }

        /** 更新预览图 */
        updatePreview = () => {
            if (!this.checkedSidewallInput) {
                this.destroyPreviewImg()
                return
            }
            if (!this.previewImg) {
                this.createPreviewImg()
            }
            const baseUrl = this.checkedSidewall.contains(this.checkedSidewallAccessoryInput) ?
                this.checkedSidewallAccessoryInput?.dataset?.previewUrl :
                this.checkedSidewallInput?.dataset?.previewUrl

            const cleanUrl = baseUrl.split('?')[0]

            const sizes = [120, 154, 240, 308, 360]

            // 生成 srcset
            const srcset = sizes
                .map(w => `${cleanUrl}?width=${w} ${w}w`)
                .join(', ')

            // 更新
            this.previewImg.src = `${cleanUrl}?width=120`
            this.previewImg.srcset = srcset
        }

        /** 删除预览图元素 */
        destroyPreviewImg = () => {
            if (!this.previewImg) return
            this.previewImg.remove()
            this.previewImg = null
            this.previewWrapper.classList.remove('has-img')
        }

        /** 创建预览图元素 */
        createPreviewImg = () => {
            if (this.previewImg) return
            this.previewImg = document.createElement('img')
            this.previewImg.width = 154
            this.previewImg.height = 110
            this.previewWrapper.appendChild(this.previewImg)
            this.previewWrapper.classList.add('has-img')
        }

        /** 移除预览效果 */
        handleClear = () => {
            if (!this.checkedSidewallInput) return
            this.checkedSidewallInput.checked = false
            this.checkedSidewallInput.dispatchEvent(new Event('change', { bubbles: true }))
        }

        /** 弹窗关闭时，需要将没有选中的sidewall下的配件选择器全部清空 */
        handlePopoverChange = evt => {
            if (evt.detail.visible) return
            this.sidewalls.forEach(sidewall => {
                if (sidewall.contains(this.checkedSidewallInput)) return
                const accessory = this.sidewallToAccessory.get(sidewall)
                if (!accessory || !accessory.triggerInput.checked) return
                accessory.triggerInput.checked = false
                accessory.triggerInput.dispatchEvent(new Event('change'))
            })
        }

        /** 边墙配件变化 */
        handleSidewallAccessoryChange = (evt) => {
            if (!this.checkedSidewallInput) return
            const { target } = evt.detail
            if (!this.checkedSidewall.contains(target)) return

            if (target.checked) {
                this.checkedSidewallAccessoryInput = target
            }

            this.publishSidewallAccessoryChangeEvent()

            if (!target.checked) {
                this.checkedSidewallAccessoryInput = null
            }

            this.updatePreview()
        }
    })
}

if (!customElements.get('ly-main-product-form-sidewall-picker-side-popover-sidewall')) {
    customElements.define('ly-main-product-form-sidewall-picker-side-popover-sidewall', class extends HTMLElement {

        connectedCallback() {
            this.previewImg = this.querySelector('.ly-main-product-form-sidewall-picker-side-popover-sidewall-image img')

            this.addEventListener('sidewall_accessory_change', this.handleSidewallAccessoryChange)
        }

        disconnectedCallback() {
            this.removeEventListener('sidewall_accessory_change', this.handleSidewallAccessoryChange)
        }

        handleSidewallAccessoryChange = evt => {
            const { target } = evt.detail

            const baseUrl = target.checked ? target.dataset.previewUrl : this.dataset.previewUrl

            if (!baseUrl || !this.previewImg) return

            // Shopify 图片去掉已有 query（避免重复拼 width）
            const cleanUrl = baseUrl.split('?')[0]

            // 常用尺寸（你原来的那套）
            const sizes = [180, 200, 360, 400, 600]

            // 生成 srcset
            const srcset = sizes
                .map(w => `${cleanUrl}?width=${w} ${w}w`)
                .join(', ')

            // 更新
            this.previewImg.src = `${cleanUrl}?width=200`
            this.previewImg.srcset = srcset
        }

        handleShowroom = () => {
            if (!this.hasAttribute('data-showroom-selected')) return
            const input = this.querySelector('.ly-main-product-form-sidewall-picker-side-popover-sidewall-picker-checkbox')
            if (!input) return
            input.checked = true
            input.dispatchEvent(new Event('change', { bubbles: true }))
        }
    })
}

if (!customElements.get('ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory')) {
    customElements.define('ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory', class extends LyMainProductFormBase {

        checkedAccessoryInput = null

        connectedCallback() {
            super.connectedCallback()

            this.triggerInput = this.querySelector('.ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-trigger-input')
            this.triggerInput.addEventListener('change', this.handleTriggerChange)

            this.accessoryWrapper = this.querySelector('.ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-items')
            this.accessoryItems = [...this.accessoryWrapper.querySelectorAll('.ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-item')]
            this.accessoryInputs = [...this.accessoryWrapper.querySelectorAll('.ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-item-picker-radio')]
            this.accessoryWrapper.addEventListener('change', this.handleAccessoryChange)
        }

        disconnectedCallback() {
            this.triggerInput.removeEventListener('change', this.handleTriggerChange)
            this.accessoryWrapper.removeEventListener('change', this.handleAccessoryChange)

            super.disconnectedCallback()
        }

        handleTriggerChange = evt => {
            const { checked } = evt.target

            this.classList.toggle('is-checked', checked)

            if (checked) {
                /** 选中触发器，默认选中第一个窗帘，并触发第一个窗帘的change事件 */
                this.accessoryInputs[0].checked = true
                this.accessoryInputs[0].dispatchEvent(new Event('change', { bubbles: true }))
            } else {
                /** 触发器取消选中时，改变当前选中窗帘的状态 */
                this.checkedAccessoryInput.checked = false
                this.checkedAccessoryInput.dispatchEvent(new Event('change', { bubbles: true }))
            }
        }

        handleAccessoryChange = (evt) => {
            const { target } = evt
            const { checked } = target

            this.checkedAccessoryInput = checked ? target : null

            this.accessoryItems.forEach(accerroryItem => {
                if (accerroryItem.contains(target)) {
                    accerroryItem.classList.toggle('is-checked', checked)
                    return
                }
                accerroryItem.classList.remove('is-checked')
            })

            this.updatePrice()
            this.dispatchEvent(new CustomEvent('sidewall_accessory_change', { bubbles: true, detail: { target } }))
        }

        updatePrice = () => {
            if (!this.currentPriceDom) {
                this.currentPriceDom = this.querySelector('.ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-current-price')
            }

            if (!this.originalPriceDom) {
                this.originalPriceDom = this.querySelector('.ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-original-price')
            }

            if (this.checkedAccessoryInput) {
                this.currentPriceDom.textContent = this.formatter.format(this.getCurrentPrice(this.checkedAccessoryInput, false) / 100)
                if (this.hasAttribute('data-in-sidewall-free-upgrade-activity')) {
                    this.currentPriceDom.textContent = 'FREE'
                }
                this.originalPriceDom.textContent = this.formatter.format(this.getOriginalPrice(this.checkedAccessoryInput) / 100)
                return
            }
            this.currentPriceDom.textContent = ''
            this.originalPriceDom.textContent = ''
        }
    })
}

if (!customElements.get('ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-free-upgrade-activity-time-counter')) {
    customElements.define('ly-main-product-form-sidewall-picker-side-popover-sidewall-accessory-free-upgrade-activity-time-counter', class extends HTMLElement {

        /** 一周毫秒数 */
        static WEEK = 7 * 24 * 60 * 60 * 1000

        intervalTimer = null
        endTime = 0

        connectedCallback() {
            this.dayDom = this.querySelector('.day')
            this.hurDom = this.querySelector('.hur')
            this.minDom = this.querySelector('.min')
            this.secDom = this.querySelector('.sec')

            this.endTime = this.parseTime(this.dataset.endTime)

            if (!this.endTime) {
                this.hidden = true
                return
            }

            // 若已过期，先向后延续一周，保证倒计时落在未来
            this.rollForwardToFuture()

            this.tick()
            this.intervalTimer = setInterval(() => this.tick(), 1000)
        }

        disconnectedCallback() {
            if (this.intervalTimer) {
                clearInterval(this.intervalTimer)
                this.intervalTimer = null
            }
        }

        /** 解析结束时间，兼容 "2026-08-10" / "2026-08-10T12:00:00Z" 等格式 */
        parseTime = value => {
            if (!value) return 0
            const time = new Date(value).getTime()
            return Number.isFinite(time) ? time : 0
        }

        /** 已过期则自动向后延续一周重新开始倒计时 */
        rollForwardToFuture = () => {
            const now = Date.now()
            while (this.endTime <= now) {
                this.endTime += this.constructor.WEEK
            }
        }

        /** 每秒刷新 */
        tick = () => {
            const remaining = this.endTime - Date.now()

            if (remaining <= 0) {
                this.rollForwardToFuture()
                return
            }

            const totalSeconds = Math.floor(remaining / 1000)
            const pad = value => String(value).padStart(2, '0')

            if (this.dayDom) this.dayDom.textContent = pad(Math.floor(totalSeconds / 86400))
            if (this.hurDom) this.hurDom.textContent = pad(Math.floor(totalSeconds % 86400 / 3600))
            if (this.minDom) this.minDom.textContent = pad(Math.floor(totalSeconds % 3600 / 60))
            if (this.secDom) this.secDom.textContent = pad(totalSeconds % 60)
        }
    })
}